import React from 'react';
import BottomSheetWebViewWrapper from '@di-shared/features/common/BottomSheetWebViewWrapper';
import SelectMonthBottomSheet from '@di-shared/features/history/driving-info/SelectMonthBottomSheet';

const BOTTOM_SHEET_FALLBACK_HEIGHT = 500;

export default function SelectMonthPage() {
  return (
    <BottomSheetWebViewWrapper bottomSheetFallbackHeight={BOTTOM_SHEET_FALLBACK_HEIGHT}>
      <SelectMonthBottomSheet />
    </BottomSheetWebViewWrapper>
  );
}
